// The AI-wand extraction dialog (ExtractAddressModal) must paint above the
// non-modal address popover card, which sits at Bootstrap's stock popover
// level (1070) — ABOVE the modal's default (1055). So the fix here is to
// raise the DIALOG above the popover layer, never to lower the popover's
// z-index (see webui-styling-style-guide.md §6). Mirrors the shipped raise
// at libs/webui/modal/src/ConfirmModal/ConfirmModal.module.scss:6-12.
.extractAddressModalRaised {
  z-index: 1085 !important;
}

.extractAddressBackdropRaised {
  z-index: 1082 !important;
}
